import React from 'react'
import { graphql, Link, useStaticQuery } from 'gatsby'
import * as styles from './nav-bar.module.css'
import { useState, useEffect } from 'react'

const NavBar = () => {
  const [visible, setVisible] = useState(false)
  const [shown, setShown] = useState(false)
  const [menu, setMenu] = useState(false)

  useEffect(() => {
    visible
      ? (document.body.style.overflow = 'hidden')
      : (document.body.style.overflow = 'auto')
  })
  const menuHandler = () => {
    setVisible((prev) => !prev)
    if (!menu) {
      setMenu((prev) => !prev)
      setTimeout(() => {
        setShown(true)
      }, 20)
    } else {
      setShown(false)
      setTimeout(() => {
        setMenu(false)
      }, 300)
    }
  }

  const handleLink = () => {
    if (visible) menuHandler()
  }

  const handleKeyDown = (ev) => {
    if (ev.keyCode === 13) {
      ev.preventDefault()
      menuHandler()
    }
  }

  const data = useStaticQuery(graphql`
    query {
      allContentfulNavigation {
        nodes {
          linkName
          order
          address
        }
      }
      contentfulLogo {
        logoImage {
          gatsbyImageData
        }
      }
    }
  `)

  return (
    <nav className={styles.navbar}>
      <div className={`${styles.logo}`}>
        {/* <GatsbyImage image={logo} alt="logo" /> */}
        <Link to="/">Frudee Web Studio</Link>
      </div>
      <div className={styles.navLinks}>
        <input type="checkbox" id="menu_toggle" />
        <div
          onClick={menuHandler}
          onKeyDown={handleKeyDown}
          aria-label="Open menu"
          role="button"
          tabIndex={0}
          className={`${styles.hamburger}`}
        >
          <span
            className={`${visible ? styles.animate : ''} ${
              styles.hamburger__bar
            }`}
          ></span>
          <span
            className={`${visible ? styles.animate : ''} ${
              styles.hamburger__bar
            }`}
          ></span>
          <span
            className={`${visible ? styles.animate : ''} ${
              styles.hamburger__bar
            }`}
          ></span>
        </div>
        <ul
          className={`${styles.menu} ${menu ? styles['shown'] : ''} ${
            shown ? styles['visuallyshown'] : ''
          }`}
        >
          {data.allContentfulNavigation.nodes
            .sort((a, b) => a.order - b.order)
            .map((node) => {
              return (
                <li key={node.order}>
                  <Link to={`/${node.address}`} onClick={handleLink}>
                    {node.linkName}
                  </Link>
                </li>
              )
            })}
        </ul>
      </div>
    </nav>
  )
}

export default NavBar
